export const formStyle = {
  padding: 0,
  border: "2px solid transparent",
  borderRadius: ".25rem",
  display: "flex",
  flexDirection: "column"
};
export default formStyle;
